import { size } from '@hubble/tokens/web';
import { VISUAL_ELEMENT_SIZE_MAP } from '../visual-elements/shared/constants.js';

const SIZE_MAP = {
  xs: size[16],
  ...VISUAL_ELEMENT_SIZE_MAP
};

export { SIZE_MAP };
